// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/main.css
 ** module id = 1
 ** module chunks = 0
 **/